<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications></notifications>
    <router-view :key="$route.params.id"></router-view>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
